module.exports = __webpack_public_path__ + "img/04.b88daf13.jpg";